import get from 'lodash.get';

const getMainLocale = (state) => get(state, 'ws.site.meta.mainLocale', null);

export default getMainLocale;
